import React from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
interface TestimonialCardProps {
  name: string;
  location: string;
  quote: string;
  image?: string;
}
export const TestimonialCard: React.FC<TestimonialCardProps> = ({
  name,
  location,
  quote
}) => {
  return <motion.div whileHover={{
    y: -4
  }} transition={{
    duration: 0.3
  }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 flex flex-col h-full hover:shadow-xl transition-shadow relative overflow-hidden" data-id="element-26">
      {/* Decorative quote icon */}
      <div className="absolute top-4 right-4 opacity-5" data-id="element-27">
        <Quote className="w-16 h-16 text-gray-900" data-id="element-28" />
      </div>

      <div className="flex gap-1 mb-5 relative z-10" data-id="element-29">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-emerald-500 text-emerald-500" data-id="element-30" />)}
      </div>

      <p className="text-gray-700 text-lg leading-relaxed mb-6 flex-grow relative z-10 italic" data-id="element-31">
        "{quote}"
      </p>

      <div className="mt-auto border-t border-gray-100 pt-5 relative z-10" data-id="element-32">
        <p className="font-bold text-gray-900 text-lg" data-id="element-33">{name}</p>
        <p className="text-sm text-gray-500 mt-1" data-id="element-34">{location}</p>
      </div>
    </motion.div>;
};